import React from "react";
import {
  StyleSheet,
  TextInput,
  TextInputProps,
  View,
  Text,
} from "react-native";
import FieldLabel from "./FieldLabel";

interface InputProps extends TextInputProps {
  type?: "default" | "email-address" | "numeric" | "phone-pad";
  editable?: boolean;
  multiline?: boolean;
  numberOfLines?: number;
  maxLength?: number;
  name: string;
  textWidth?: number;
  inputWidth?: number;
  required?: boolean;
  placeholder?: string;
  style?: any;
  inputHeight?: number;
  labelStyle?: any;
  containerStyle?: any;
  tooltipText?: string;
  tooltipAccessibilityLabel?: string;
  tooltipTrackingEventName?: string;
  tooltipTrackingProperties?: Record<string, unknown>;
}

const InputPatientDetail = React.forwardRef<TextInput, InputProps>(
  (
    {
      type = "default",
      name,
      placeholder = "",
      value,
      onChangeText,
      style,
      inputHeight = 30,
      textWidth = 120,
      editable = true,
      multiline = false,
      numberOfLines = 1,
      maxLength = 50,
      labelStyle,
      containerStyle,
      tooltipText,
      tooltipAccessibilityLabel,
      tooltipTrackingEventName,
      tooltipTrackingProperties,
      ...otherProps
    },
    ref,
  ) => {
    const handleChangeText = (text: string) => {
      if (onChangeText) {
        onChangeText(text);
      }
    };

    const inputValue =
      value === undefined || value === null ? "" : String(value);

    return (
      <View style={[styles.container, containerStyle]}>
        <FieldLabel
          text={name}
          width={textWidth}
          tooltipText={tooltipText}
          tooltipAccessibilityLabel={tooltipAccessibilityLabel}
          tooltipTrackingEventName={tooltipTrackingEventName}
          tooltipTrackingProperties={tooltipTrackingProperties}
          labelStyle={labelStyle}
        />
        <TextInput
          ref={ref}
          editable={editable}
          multiline={multiline}
          numberOfLines={numberOfLines}
          maxLength={maxLength}
          style={[
            styles.textInput,
            { height: inputHeight },
            { color: inputValue ? "#282B33" : "#C4C6CD" },
            style,
          ]}
          value={inputValue}
          keyboardType={type}
          placeholder={placeholder}
          onChangeText={handleChangeText}
          {...otherProps}
        />
      </View>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  name: {
    fontFamily: "Urbanist500",
    fontWeight: "500",
    fontSize: 16,
    color: "#282B33",
  },
  textInput: {
    paddingVertical: 8,
    width: "100%",
    maxWidth: 260,
    fontFamily: "Urbanist500",
    fontWeight: "500",
    borderRadius: 10,
    borderColor: "#C4C6CD",
    borderWidth: 1,
    paddingHorizontal: 12,
    fontSize: 16,
    color: "#000000",
    backgroundColor: "#fff",
  },
});

export default InputPatientDetail;
